import en from './en';
import fr from './fr';

export const CSQ_SUPPORTED_LANGUAGES = ['en', 'fr'];

export const CSQ_DEFAULT_LANGUAGE = 'en';

export const CSQ_STRINGS = { en, fr };
